import { Button, Col, Row, Table, Typography } from 'antd';
import locale from 'antd/es/locale/pt_BR';

import InvestimentoFormModal from './components/InvestimentoFormModal';
import { useInvestimentosACadastrar } from './useInvestimentosACadastrar';

const { Text } = Typography;

const InvestimentosACadastrar = () => {
    const {
        clickBotaoCadastrarInvestimento,
        hasSelectedCadastrar,
        loadingTable,
        onclickTable,
        rowSelection,
        investimentosACadastrar,
        columns,
        refContagemDoFiltro,
        propsState,
        handleResetRowSelection,
        investimentoSelecionado,
        handleCloseModal,
        handleInvestimentoCreated,
    } = useInvestimentosACadastrar();

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    zIndex: 2,
                    paddingTop: 24,
                    paddingBottom: 10,
                    paddingLeft: 24,
                    paddingRight: 10,
                    margin: -24
                }}
            >
                <Row>
                    <Col>
                        <Button
                            type="primary"
                            style={{ marginRight: 5, marginBottom: 5 }}
                            className="btn_success_vlhbegoawrgbvr"
                            onClick={clickBotaoCadastrarInvestimento}
                            disabled={!hasSelectedCadastrar}
                        >
                            Cadastrar
                        </Button>
                    </Col>
                </Row>
            </div>

            <Table
                style={{
                    marginTop: 50
                }}
                className="marginTopTables"
                rowClassName={() => "ativoList"}
                rowKey={(record) => record.id}
                loading={loadingTable}
                onRow={(record) => {
                    return {
                        onClick: () => { onclickTable(record) },
                    };
                }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={investimentosACadastrar}
                scroll={{ x: 1200 }}
                onChange={(_, __, ___, extra) => {
                    handleResetRowSelection();
                    refContagemDoFiltro.current = extra.currentDataSource;
                }}
                title={(registros) => {
                    return (
                        <div
                            style={{
                                backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    investimentosACadastrar.length :
                                    refContagemDoFiltro.current.length} num total de ${investimentosACadastrar.length} `}
                            </Text>
                        </div>
                    );
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: 'end'
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    investimentosACadastrar.length :
                                    refContagemDoFiltro.current.length} num total de ${investimentosACadastrar.length} `}
                            </Text>
                        </div>
                    );
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    position: ['topRight', 'bottomRight'],
                    pageSizeOptions: ['10', '20', '50', '100']
                }}
                locale={locale.Table}
            />

            <InvestimentoFormModal
                visible={!!investimentoSelecionado}
                investimento={investimentoSelecionado}
                onClose={handleCloseModal}
                onInvestimentoCreated={handleInvestimentoCreated}
            />
        </>
    );
};

export default InvestimentosACadastrar;
